import React from 'react';

const About = () => (
  <div className="flex items-center justify-center flex-grow h-full">
    <span className="text-md title-font tracking-wider text-gray-600">
      Made by{' '}
      <a
        href="https://github.com/hdn7"
        className="text-lg text-white font-bold"
      >
        Hieu Do Ngoc
      </a>
    </span>
  </div>
);

export default About;
